const ITEMS = [
  "FTSO Data Provider",
  "Anchor Updates",
  "Fast Updates",
  "Flare Mainnet",
  "Flare Validators",
  "Flare Data Connector",
];

function List({ hidden = false }) {
  return (
    <ul className="marquee-list" aria-hidden={hidden || undefined}>
      {ITEMS.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
}

export default function Marquee() {
  return (
    <div className="marquee" data-testid="protocol-marquee">
      <div className="marquee-track">
        <List />
        <List hidden />
      </div>
    </div>
  );
}
